import moment from 'moment'
import type { FormItemProps } from 'antd'

import {
  type ProductSummaryFragment,
  ProductType,
} from '~/gql/generated/graphql'

export const formatCap = ({
  billable_journey_cap_sub_period,
  billable_journey_cap,
}: ProductSummaryFragment) => {
  if (billable_journey_cap && billable_journey_cap_sub_period) {
    const duration = moment
      .duration(billable_journey_cap_sub_period)
      .humanize()
      .replace('a ', '') // e.g. "a day" -> "day"
    return `${billable_journey_cap} per ${duration}`
  }
  return null
}

export const formatDuration = (duration: string | null | undefined) => {
  return duration ? moment.duration(duration).humanize() : ''
}

export const isAMinutePass = (productType: ProductType) =>
  [ProductType.period_pass, ProductType.bundle].includes(productType)
export const isAPeriodPass = (productType: ProductType) =>
  productType === ProductType.period_pass
export const isASubscriptionPass = (productType: ProductType) =>
  productType === ProductType.subscription_pass
export const isBuyableProduct = (productType: ProductType) =>
  productType !== ProductType.payg

type AnyObject = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: AnyObject | any
}

/**
 * Traverse an obect replacing {__typename: "FormattedAmount", amount: n} with just the amount value
 * to populate a state that can be used for saving back to the API
 */
export const transformCurrencyFields = (obj: AnyObject) => {
  if (Array.isArray(obj)) {
    return obj.map(item => transformCurrencyFields(item))
  }

  if (obj && typeof obj === 'object') {
    if (obj.__typename === 'FormattedAmount') {
      return obj.amount
    }

    const transformed = {}
    for (const key in obj) {
      transformed[key] = transformCurrencyFields(obj[key])
    }
    return transformed
  }

  return obj
}

export const currencyFormItemConversionProps: Pick<
  FormItemProps,
  'getValueProps' | 'normalize'
> = {
  // Convert from pence to pounds for the initial value
  getValueProps: (value: number) => ({
    value: value != null ? value / 100 : 0,
  }),
  // Convert from pounds to pence before storing
  normalize: (value: number) => Math.round((value ?? 0) * 100),
}
